import { Contract } from "../api/service";

export const useContract = () => {
  const getHistory = Contract.GET.getHistory;
  const getContractList = Contract.GET.getContractList;
  const getContractById = Contract.GET.getContractById;
  const getAdditionalList = Contract.GET.getAdditionalList;
  const getAdditionalById = Contract.GET.getAdditionalById;
  const addAdditional = Contract.POST.addAdditional;
  const addContract = Contract.POST.addContract;
  const printTemplate = Contract.POST.printTemplate;
  const updateContract = Contract.PUT.updateContract;
  const updateAdditional = Contract.PUT.updateAdditional;

  return {
    getHistory,
    getContractList,
    getContractById,
    getAdditionalList,
    getAdditionalById,
    addAdditional,
    addContract,
    printTemplate,
    updateContract,
    updateAdditional,
  };
};
